module.exports = __webpack_public_path__ + "img/neuroleap_logo_transparent.5a72adfb.png";